import React, { useEffect, useState, useRef } from "react";
// import moment from "moment-timezone";
import "../../../styles/live-subscriptions/membership-notification.css";
import notificationSound from "../../../assets/sounds/bca_pending.mp3";
// import notificationSound from "../../../assets/vocal-sound/vocal_bca_pending.mp3";
// import {
//   CallIcon,
//   EmailIcon,
//   LocationIcon1,
//   PersonIcon,
// } from "../../../images/icons/icons";
import MemberBasicInfo from "../MemberBasicInfo";
import FooterTags from "../FooterTags";
import ToaserInfo from "../ToaserInfo";

const BCAWebhook = ({ userInfoData, setStatsData, setAllDatas }) => {
  const audioRef = useRef(null);
  const wsRef = useRef(null);
  const wsBackoffRef = useRef(2000);
  const processedWebhookEvents = useRef(new Set());

  const [notifications, setNotifications] = useState([]);
  const [activeTab, setActiveTab] = useState(0);

  const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);

  const playNotificationSound = () => {
    try {
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        audioRef.current.play().catch((error) => {});
      }
    } catch (error) {}
  };

  const showBCANotification = (bcaData) => {
    console.log("bcaData=> ", bcaData);

    const eventId = `${bcaData?.user_name || ""}_${
      bcaData?.user_mobile || ""
    }_${bcaData?.pt_trial_id || ""}_${Date.now()}`;

    const now = Date.now();
    const existingEvent = Array.from(processedWebhookEvents.current).find(
      (item) => {
        const [id, timestamp] = item.split("_TIMESTAMP_");
        return (
          id.includes(bcaData?.user_name || "") &&
          id.includes(bcaData?.user_mobile || "") &&
          now - parseInt(timestamp) < 10000
        );
      }
    );

    if (existingEvent) {
      return;
    }

    const eventWithTimestamp = `${eventId}_TIMESTAMP_${now}`;
    processedWebhookEvents.current.add(eventWithTimestamp);

    processedWebhookEvents.current.forEach((item) => {
      const [, timestamp] = item.split("_TIMESTAMP_");
      if (now - parseInt(timestamp) > 30000) {
        processedWebhookEvents.current.delete(item);
      }
    });

    const notification = bcaData || {};
    // const notification = {
    //   id: bcaData?.id || Date.now() + Math.random(),
    //   uid: bcaData?.uid || null,
    //   user_id: bcaData?.user_id || null,
    //   trainer_id: bcaData?.trainer_id || null,
    //   pt_trial_id: bcaData?.pt_trial_id || null,
    //   three_day_done_count: bcaData?.three_day_done_count || "0",
    //   gym_id: bcaData?.gym_id || null,
    //   success: 1,
    //   error_message: null,
    //   status: "active",
    //   date_added:
    //     bcaData?.date_added ||
    //     moment().tz("Asia/Kolkata").format("YYYY-MM-DD HH:mm:ss"),
    //   last_updated:
    //     bcaData?.last_updated ||
    //     moment().tz("Asia/Kolkata").format("YYYY-MM-DD HH:mm:ss"),
    //   three_day_assigned: bcaData?.three_day_assigned || 0,
    //   three_day_id: bcaData?.three_day_id || null,
    //   current_subscription_id: bcaData?.current_subscription_id || null,
    //   user_name: bcaData?.user_name || "NA",
    //   trainer_name: bcaData?.trainer_name || "NA",
    //   gym_name: bcaData?.gym_name || "NA",
    //   trainer_mobile: bcaData?.trainer_mobile || "NA",
    //   trainer_email: bcaData?.trainer_email || "NA",
    //   user_mobile: bcaData?.user_mobile || "NA",
    //   user_email: bcaData?.user_email || "NA",
    //   is_renewal: bcaData?.is_renewal || 0,
    //   timestamp: Date.now(),
    // };

    setNotifications((prev) => {
      const newNotifications = [notification, ...prev];

      return newNotifications;
    });
    playNotificationSound();

    if (setStatsData) {
      setStatsData((prev) => {
        const currentTotal = Number(prev.total) || 0;
        const currentPending = Number(prev.pending_bca) || 0;

        return {
          ...prev,
          total: currentTotal + 1,
          pending_bca: currentPending + 1,
        };
      });
    }

    if (setAllDatas) {
      setAllDatas((prev) => ({
        ...prev,
        allData: [notification, ...prev.allData],
      }));
    }

    setTimeout(() => {
      setNotifications((prev) => {
        const updated = prev.filter((n) => n.id !== notification.id);
        if (activeTab >= updated.length && updated.length > 0) {
          setActiveTab(updated.length - 1);
        }
        return updated;
      });
    }, 95000);
  };

  useEffect(() => {
    const WS_URL = process.env.REACT_APP_ODM_WSS_URL;
    if (!WS_URL || !userInfoData || isIOS()) return;

    let stopped = false;

    const computeChannels = () => {
      try {
        const acc = userInfoData?.account_type;
        const channels = [];

        if (acc === "receptionist" && userInfoData?.gym_id) {
          channels.push(`bca:gym:${userInfoData.gym_id}`);
        }
        if (acc === "cluster_manager") {
          const userGyms = userInfoData?.gyms?.gyms || userInfoData?.gyms || [];
          if (Array.isArray(userGyms)) {
            userGyms.forEach((g) => {
              const gid = g?.value || g?.gym_id || g?.uid || g;
              if (gid) channels.push(`bca:gym:${gid}`);
            });
          }
        }
        if (acc === "admin") {
          channels.push("bca:global");
        }

        return Array.from(new Set(channels));
      } catch {
        return [];
      }
    };

    const connect = () => {
      if (stopped) return;
      try {
        const token = encodeURIComponent(userInfoData?.token || "");
        const ws = new WebSocket(`${WS_URL}?token=${token}&type=bca`);
        wsRef.current = ws;

        ws.onopen = () => {
          wsBackoffRef.current = 2000;
          const channels = computeChannels();

          try {
            ws.send(
              JSON.stringify({
                type: "SUBSCRIBE",
                channels: channels,
                event_filter: ["bca_pending"],
              })
            );
          } catch (e) {}
        };

        ws.onmessage = (e) => {
          try {
            const msg = JSON.parse(e.data);

            if (msg?.event_type === "bca_pending" && msg?.data && msg?.status) {
              showBCANotification(msg.data);
            } else {
            }
          } catch (err) {}
        };

        ws.onclose = () => {
          if (stopped) return;
          const delay = Math.min(wsBackoffRef.current, 30000);
          setTimeout(connect, delay);
          wsBackoffRef.current = Math.min(wsBackoffRef.current * 2, 30000);
        };

        ws.onerror = () => {
          try {
            ws.close();
          } catch {}
        };
      } catch {
        const delay = Math.min(wsBackoffRef.current, 30000);
        setTimeout(connect, delay);
        wsBackoffRef.current = Math.min(wsBackoffRef.current * 2, 30000);
      }
    };

    connect();

    return () => {
      stopped = true;
      try {
        if (wsRef.current && wsRef.current.readyState === 1) {
          wsRef.current.close();
        }
      } catch {}
    };
  }, [userInfoData]);

  useEffect(() => {
    if (audioRef.current) {
      const audio = audioRef.current;

      audio.addEventListener("loadstart", () => {});

      audio.addEventListener("canplay", () => {});

      audio.addEventListener("canplaythrough", () => {});

      audio.addEventListener("error", (e) => {});

      audio.load();
    }
  }, []);

  useEffect(() => {
    if (notifications.length > 0) {
      setActiveTab(0);
    }
  }, [notifications.length]);

  // const testAudio = () => {
  //   if (audioRef.current) {
  //     audioRef.current.currentTime = 0;
  //     audioRef.current
  //       .play()
  //       .then(() => {})
  //       .catch((error) => {});
  //   }
  // };

  return (
    <>
      <audio
        ref={audioRef}
        preload="auto"
        src={notificationSound}
        style={{ display: "none" }}
      />

      {/* <button
        onClick={testAudio}
        style={{
          position: "fixed",
          top: "10px",
          left: "10px",
          zIndex: 10000,
          padding: "10px",
          background: "red",
          color: "white",
          border: "none",
        }}
      >
        🔊 Test BCA Audio
      </button> */}

      {notifications.length > 0 && (
        <div className="live-subscription-membership-notifications-container">
          <div className="live-subscription-feed-modal">
            <div className="live-subscription-modal-header">
              <div>
                <h2 className="live-subscription-modal-title">
                  BCA Pending Feed
                </h2>
                <p className="live-subscription-active-count">
                  {notifications.length} Pending BCA
                </p>
              </div>
              <button
                className="live-subscription-close-modal-btn"
                onClick={() => setNotifications([])}
              >
                ×
              </button>
            </div>

            <div className="live-subscription-tab-navigation">
              {notifications.map((notification, index) => {
                return (
                  <button
                    key={notification.id}
                    className={`live-subscription-tab-item ${
                      index === activeTab ? "active" : ""
                    }`}
                    onClick={() => setActiveTab(index)}
                  >
                    #{index + 1}
                  </button>
                );
              })}
            </div>

            {notifications[activeTab] && (
              <div className="live-subscription-membership-notification-card">
                {/* <div className="live-subscription-member-info-section">
                  <div className="live-subscription-member-basic-info">
                    <div className="live-subscription-member-name">
                      <div className="live-subscription-member-name-left">
                        <PersonIcon />
                        {notifications[activeTab]?.user_name || "NA"}
                      </div>
                      {(notifications[activeTab]?.is_renewal === 1 ||
                        notifications[activeTab]?.is_renewal === 0) && (
                        <span
                          className={`tb-badge ${
                            notifications[activeTab]?.is_renewal === 1
                              ? "tb-existing"
                              : notifications[activeTab]?.is_renewal === 0
                              ? "tb-fresh"
                              : ""
                          }`}
                        >
                          {notifications[activeTab]?.is_renewal === 1
                            ? "Existing Member"
                            : notifications[activeTab]?.is_renewal === 0
                            ? "Fresh"
                            : "NA"}
                        </span>
                      )}
                    </div>
                    <div className="live-subscription-member-phone">
                      <CallIcon />
                      {notifications[activeTab]?.user_mobile || "NA"}
                    </div>
                    <div className="live-subscription-gym-location">
                      <LocationIcon1 />
                      {notifications[activeTab]?.gym_name || "NA"}
                    </div>
                  </div>
                </div> */}

                {/* <div className="live-subscription-subscription-details">
                  <div className="live-subscription-detail-item">
                    <div className="live-subscription-detail-icon">
                      <PersonIcon />
                    </div>
                    <div className="live-subscription-detail-label">
                      Trainer
                    </div>
                    <div className="live-subscription-detail-value">
                      {notifications[activeTab]?.trainer_name || "-"}
                    </div>
                  </div>

                  <div className="live-subscription-detail-item">
                    <div className="live-subscription-detail-icon">
                      <CallIcon />
                    </div>
                    <div className="live-subscription-detail-label">
                      Trainer Mobile
                    </div>
                    <div className="live-subscription-detail-value">
                      {notifications[activeTab]?.trainer_mobile || "-"}
                    </div>
                  </div>

                  <div className="live-subscription-detail-item">
                    <div className="live-subscription-detail-icon">
                      <CallIcon />
                    </div>
                    <div className="live-subscription-detail-label">
                      subscription expiring in
                    </div>
                    <div className="live-subscription-detail-value">
                      {notifications[activeTab]
                        ?.current_subscription_expiry_days || "NA"}
                    </div>
                  </div>

                  <div className="live-subscription-detail-item">
                    <div className="live-subscription-detail-icon">
                      <EmailIcon />
                    </div>
                    <div className="live-subscription-detail-label">
                      trainer email
                    </div>
                    <div className="live-subscription-detail-value lowercase">
                      {notifications[activeTab]?.trainer_email || "NA"}
                    </div>
                  </div>
                </div> */}

                {/* <div className="live-subscription-membership-badges">
                  <div className="live-subscription-membership-badge regular">
                    BCA Pending
                  </div>
                </div> */}

                <MemberBasicInfo
                  rowData={notifications[activeTab]}
                  customTitle="BCA Pending Member"
                />

                <ToaserInfo
                  from="bca_pending"
                  rowData={notifications[activeTab]}
                />

                <FooterTags
                  from="bca_pending"
                  rowData={notifications[activeTab]}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default BCAWebhook;
